import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockSubHeroFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const subHeroBlockConfig = {
  name: 'outer-block-sub-hero',
  component: defineAsyncComponent(() => import('./CmsSubHeroSection.vue')),
  innerComponent: defineAsyncComponent(() => import('./SubHeroSection.vue')),
  fields: blockSubHeroFields,
} satisfies ModularBlockConfig;
